import React from "react";

import SyncIcon from "@mui/icons-material/Sync";
import SyncProblemIcon from "@mui/icons-material/SyncProblem";
import Button from "../../Button";

export default function BroadCastButton({
  onPress = () => {},
  isdraft = false,
  size = "medium",
}) {
  const onButtonPress = () => {
    isdraft && onPress();
  };

  const buttonColor = isdraft ? "#E87033" : "#9B5AF8";

  return (
    <Button
      onClick={onButtonPress}
      style={{
        marginRight: 1,
        textTransform: "none",
        color: buttonColor,
        borderColor: buttonColor,
        ...(size === "small"
          ? {
              width: "auto",
              minHeight: 22,
              display: "inline-block",
              marginRight: 5,
              backgroundColor:"transparent",
            }
          : {}),
      }}
      variant="outlined"
    >
      {isdraft ? (
        <SyncProblemIcon style={{ marginRight: 3 }} />
      ) : (
        <SyncIcon style={{ marginRight: 3 }} fontSize={"small"} />
      )}
      Synchronize
    </Button>
  );
}
